import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import './TicketsListSkeleton.scss';

export const TicketsListSkeleton = () => {
  return (
    <div className='tickets-list-skeleton'>
      {Array.from({ length: 5 }).map((_, index) => (
        <div key={index} className='ticket-item-skeleton'>
          <div className='ticket-header-skeleton'>
            <div className='ticket-title-skeleton'>
              <Skeleton shape='circle' width='16px' height='16px' className='type-icon-skeleton' />
              <Skeleton width='60%' height='20px' className='title-skeleton' />
            </div>
            <Skeleton width='100px' height='24px' className='status-badge-skeleton' />
          </div>
          <div className='ticket-meta-skeleton'>
            <Skeleton width='120px' height='24px' className='meta-badge-skeleton' />
            <Skeleton width='120px' height='24px' className='meta-badge-skeleton' />
          </div>
        </div>
      ))}
    </div>
  );
};
